import { IOnboardingUserData } from '../interfaces/models';

export class OnboardingUser implements IOnboardingUserData {
  public id: string | number;

  public firstName?: string;
  // Date of account creation
  public createdAt?: string;
  // Referente ao perfil de investidor do usuário, Ex: Moderado, Arrojado, Conservador
  public suitability?: string;
  // Tipo do usuário, eX: Ativo, Cadastrado, Cadastro Não terminado
  public accountStatus?: string;
  // Valor em conta do usuário
  public accountBalance?: number;
  // O usuário é assinante de algum plano?
  public isASubscriber?: boolean; // comentar
  // Qual o nível de permissão do usuário?
  public userPermissionRole?: string; // comentar
  // É um tester?
  public isATester?: boolean; // retirar
  // Is in Mobile app?
  public isInMobileApp?: boolean = false;

  public availableForWithdrawal?: boolean = false;

  public isAnonymus?: boolean = false;

  public isFirstActivatedLogin?: boolean = false;

  public gender?: string;

  public patrimonyBalance?: number;

  public totalFixedIncome?: number;

  public totalExchange?: number;

  public totalFunds?: number;

  public percentTotalFixedIncome?: number;

  public percentTotalExchange?: number;

  public percentTotalFunds?: number;

  public showFlow?: string;

  public showChecklist?: string;

  public toroMais?: boolean;
  // usuário possui o infoproduto Toro+
  public turboTrader?: boolean;
  // usuário possui o infoproduto Turbo Trader

  public proprietariosdofuturo?: boolean;

  public pioneiros?: boolean;

  public torozero?: boolean;

  public traditional?: boolean;

  public winwin?: boolean;

  public movablePropertiesValue?: number;

  public suitabilityInvestmentsValue?: number;

  public  screenSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  public campaignName?: string;

    // Onboarding Question Answer P&D Team - Don´t REMOVE
    //public onboarding1Question1Answer = 0;
    //public onboarding1Question2Answer = 0;
    //public onboarding1Question3Answer = 0;
    // public onboarding4000Question3Answer = 0;

  constructor({
      id,
      firstName,
      createdAt,
      suitability,
      accountStatus,
      accountBalance,
      isASubscriber,
      userPermissionRole,
      isATester,
      isInMobileApp,
      isFirstActivatedLogin,
      gender,
      patrimonyBalance,
      totalFixedIncome,
      totalExchange,
      totalFunds,
      toroMais,
      turboTrader,
      pioneiros,
      proprietariosdofuturo,
      torozero,
      traditional,
      winwin,
      movablePropertiesValue,
      suitabilityInvestmentsValue,
      campaignName
  }: IOnboardingUserData | any) {
      this.id = id;
      this.firstName = firstName;
      this.createdAt = createdAt;
      this.suitability = suitability;
      this.accountStatus = accountStatus;
      this.accountBalance = accountBalance;
      this.isASubscriber = isASubscriber;
      this.userPermissionRole = userPermissionRole;
      this.isATester = isATester;
      this.isInMobileApp = isInMobileApp;
      this.isFirstActivatedLogin = isFirstActivatedLogin;
      this.gender = gender;
      this.patrimonyBalance = patrimonyBalance;
      this.totalFixedIncome = totalFixedIncome;
      this.totalExchange = totalExchange;
      this.totalFunds = totalFunds;
      this.toroMais = toroMais;
      this.turboTrader = turboTrader;
      this.pioneiros = pioneiros;
      this.proprietariosdofuturo = proprietariosdofuturo;
      this.torozero = torozero;
      this.traditional = traditional;
      this.winwin = winwin;
      this.movablePropertiesValue = movablePropertiesValue;
      this.suitabilityInvestmentsValue = suitabilityInvestmentsValue;
      this.campaignName = campaignName;
  }
}
